import React, {useContext} from 'react';
import {filter, map} from 'lodash';
import {ImpostorModeContext} from 'src/components/ImpostorModeContext';
import BottomMobileDrawer, {
  DrawerItem,
} from '../../../src/apps/mobile/components/BottomMobileDrawer/BottomMobileDrawer';
import UserIcon from '../../img/user.svg';
import {useDispatch} from 'react-redux';
import switchAccount from 'shared/actions/switch-account';
import {useBoolean} from 'src/hooks/useBoolean';
import ConnectionButton from './connection-button';

interface UserConnection {
  connectedUser: {
    _id: string;
    firstName: string;
    impersonatedUser?: boolean;
  };
  status: string;
}

const MobileConnectionsList = () => {
  const impostorModeContext = useContext(ImpostorModeContext);
  const acceptedConnections = filter(impostorModeContext.userConnections, {
    status: 'accepted',
  }) as UserConnection[];

  const dispatch = useDispatch();
  const show = useBoolean(false);

  const drawerItems: DrawerItem[] = map(acceptedConnections, ({connectedUser}) => ({
    Icon: UserIcon,
    text: connectedUser.firstName,
    onClick: () =>
      dispatch(
        switchAccount(connectedUser._id, 'Switch account in impostor toolbar connections list')
      ),
  }));

  return (
    <>
      <ConnectionButton onClick={show.setTrue} />
      <BottomMobileDrawer header="Select Student" drawerItems={drawerItems} show={show} />
    </>
  );
};

export default MobileConnectionsList;
